import {
    Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle
} from 'shared/components/ui/dialog';
import {
    Label
} from 'shared/components/ui/label';
import {
    useContext, useEffect, useState
} from 'react';
import {
    SubOrgContext
} from 'shared/context/SubOrganizationContext';
import {
    Combobox
} from 'shared/components/ui/combobox';
import {
    Button
} from 'shared/components/ui/button';
import {
    FileSelection
} from './FileList';
import {
    getFileSystem
} from './FileSystemHelper';
import {
    useParams
} from 'react-router-dom';
import {
    Context
} from 'shared/context/GlobalState';
import {
    LoaderSpinner
} from 'shared/components/LoaderSpinner';

// Allowed image file extensions for selection
const ALLOWED_IMAGE_EXTENSIONS = [
    'jpg',
    'jpeg',
    'png',
    'webp',
    'gif'
];

export function ImageSelectionModal({
    isOpen, onClose, handleImageSelect
}) {
    const {
        collections, fetchCollections
    } = useContext(SubOrgContext);
    const {
        addNewNotifcation
    } = useContext(Context);

    useEffect(() => {
        if (isOpen) {
            fetchCollections();
        }
    }, [isOpen]);

    const [selectedCollection, setSelectedCollection] = useState(null);
    const [fileSystem, setFileSystem] = useState([]);
    const [isFetchingFiles, setIsFetchingFiles] = useState(false);
    const [selectedFiles, setSelectedFiles] = useState([]);

    const {
        oragID, subOragID
    } = useParams();

    const closeImageSelectionModal = () => onClose();

    const initializeFileSystem = async () => {
        try {
            setFileSystem([]);

            setIsFetchingFiles(true);

            const files = await getFileSystem(collections, oragID, subOragID, selectedCollection?._id);
            setFileSystem(files);

            addNewNotifcation('Files fetched successfully.', 'success');
        } catch (error) {
            console.error('Failed to fetch files:', error);
            addNewNotifcation('Could not retrieve the files after multiple attempts.', 'danger');
        } finally {
            setIsFetchingFiles(false);
        }
    };

    const onFileClick = (fileList) => {
        setSelectedFiles(fileList);
    };

    useEffect(() => {
        if (selectedCollection?._id && selectedCollection?._id != '')
            initializeFileSystem();
    }, [selectedCollection?._id]);

    // useEffect(() => {
    //
    // }, [selectedFiles])

    return (
        <Dialog open={isOpen} onOpenChange={onClose}>
            <DialogContent className="sm:max-w-6xl select-none h-fit max-h-[800px] min-h-[300px]">
                <DialogHeader>
                    <DialogTitle>Input Data Image Selection</DialogTitle>
                    <DialogDescription>
                        Select an image file from the collection.
                    </DialogDescription>
                </DialogHeader>
                <div className="w-full">
                    <Label>Collection</Label>
                    <div className="flex flex-col gap-2">
                        <Combobox
                            id="collection-combobox"
                            comboboxWidth='w-[300PX]'
                            items={collections}
                            setter={setSelectedCollection}
                            selectedValue={selectedCollection}
                            disabled={collections?.length === 0}
                        />

                        {isFetchingFiles ?
                            <div className="flex flex-row mx-auto gap-2 h-fit text-gray-400">
                                <span>Fetching Files</span>
                                <LoaderSpinner className='w-6 h-6' />
                            </div>
                            : !fileSystem ?
                                <div className="flex flex-row mx-auto gap-2 h-fit text-gray-400">
                                    <span>No Files</span>
                                </div>
                                : <FileSelection
                                    fileSystem={fileSystem}
                                    onFileClick={onFileClick}
                                    multiple={false}
                                    allowedExtensions={ALLOWED_IMAGE_EXTENSIONS}
                                />}

                        <Button
                            disabled={selectedFiles.length === 0}
                            onClick={() => {
                                handleImageSelect(selectedFiles);
                                closeImageSelectionModal();
                            }}>
                            Select
                        </Button>
                    </div>
                </div>
            </DialogContent>
        </Dialog>
    );
}